var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdiliaClark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.003,
    height: 22.79,
    viewBox: "0 0 144.003 22.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31255",
    "data-name": "Group 31255",
    transform: "translate(12116 8864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10752",
    "data-name": "Group 10752",
    transform: "translate(-12116 -8864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M6.215,0a5.962,5.962,0,0,1,6.217,5.938,6.073,6.073,0,0,1-6.217,6.077A5.989,5.989,0,0,1,0,5.938,5.878,5.878,0,0,1,6.215,0Zm0,9.943a3.784,3.784,0,0,0,3.729-4A3.665,3.665,0,0,0,6.215,2.072,3.746,3.746,0,0,0,2.486,5.938,3.868,3.868,0,0,0,6.215,9.943Z",
    transform: "translate(0 0.007)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M16.667,11.7H12.8V.1h3.867C20.4.1,23.02,2.172,23.02,5.9S20.534,11.7,16.667,11.7ZM16.8,2.171H15.286v7.6H16.8c2.209,0,3.867-1.243,3.867-3.729A3.619,3.619,0,0,0,16.8,2.172Z",
    transform: "translate(4.877 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M26.448.1V11.7H24.1V.1Z",
    transform: "translate(9.183 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M30.3.1h2.348V9.629h4.7V11.7H30.3Z",
    transform: "translate(11.545 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M41.648.1V11.7H39.3V.1Z",
    transform: "translate(14.974 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M65.914-.007a6.3,6.3,0,0,1,3.176.69l-.69,1.8a6.69,6.69,0,0,0-2.486-.415,3.784,3.784,0,0,0-3.729,4,3.806,3.806,0,0,0,3.867,4A4.232,4.232,0,0,0,68.4,9.522l.69,1.932a8.192,8.192,0,0,1-3.176.69A5.957,5.957,0,0,1,59.7,6.205,6.18,6.18,0,0,1,65.914-.007Z",
    transform: "translate(18.29 0.014)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M70.6.1h2.348V9.629h4.7V11.7H70.6Z",
    transform: "translate(22.442 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M95.31,8.11,99.039,11.7H96L92.548,8.248V11.7H90.2V.1h4c2.9,0,4.557,1.8,4.557,4A4.011,4.011,0,0,1,95.31,8.11ZM92.548,6.453h1.243q2.486,0,2.486-2.072a1.932,1.932,0,0,0-2.209-2.072h-1.52V6.452Z",
    transform: "translate(30.405 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M109.513.1l-4.281,5.938,4.975,5.662h-3.038l-4.421-5.11V11.7H100.4V.1h2.348V5.762L106.615.1Z",
    transform: "translate(33.797 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M50.162,3.553,53.476,11.7h2.348L51.129.1H49.2L44.5,11.7h2.486Z",
    transform: "translate(16.955 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M45.9,6.6l1.243-1.8,8.148,5.11H51.838Z",
    transform: "translate(17.488 1.836)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M84.562,3.553,87.738,11.7h2.348L85.529.1H83.6L78.9,11.7h2.486Z",
    transform: "translate(25.605 0.045)",
    fill: "#18364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M80.2,6.6l1.243-1.8,8.148,5.11H86.138Z",
    transform: "translate(26.1 1.836)",
    fill: "#18364c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25956",
    "data-name": "Path 25956",
    d: "M-118.968-4.227h.612V-8.322h-.612Zm7.463,0-.5-4.095h-.545l-1.409,2.948-1.415-2.948h-.545l-.5,4.095h.606l.363-2.972,1.23,2.52h.523l1.218-2.52.363,2.972Zm3.584-4.095h-1.64v4.095h.612V-5.742h1.028A1.185,1.185,0,0,0-107-6.1a1.185,1.185,0,0,0,.331-.927,1.2,1.2,0,0,0-.33-.93,1.2,1.2,0,0,0-.916-.366Zm-.036,2.021h-.991V-7.763h1.016a.66.66,0,0,1,.488.224.66.66,0,0,1,.16.513.658.658,0,0,1-.172.515.658.658,0,0,1-.5.211Zm5.428,2.074h.644l-1.547-4.095h-.654l-1.551,4.095h.644l.38-1.034h1.7Zm-1.89-1.569.654-1.765.654,1.765Zm4.156,1.569h.612V-8.322h-.612Zm4.915,0h.731l-1.09-1.539a1.169,1.169,0,0,0,1.052-1.26,1.2,1.2,0,0,0-.334-.935,1.2,1.2,0,0,0-.926-.36h-1.563v4.095h.612V-5.754h.47Zm-1.516-3.536h.945a.665.665,0,0,1,.49.224.665.665,0,0,1,.163.513c0,.434-.232.737-.8.737h-.8Zm8.83,3.536-.5-4.095h-.545l-1.409,2.948-1.409-2.948h-.545l-.5,4.095h.6l.363-2.972,1.232,2.52h.523L-89-7.2l.363,2.972Zm2.55-.559V-5.956h1.611v-.565h-1.611V-7.763h1.848v-.559H-86.09v4.095h2.508v-.559Zm6.191-3.536v2.96l-1.771-2.96h-.594v4.095h.612V-7.21l1.791,2.984h.576V-8.322Zm5.4,0h-3.045v.559h1.218v3.536h.612V-7.763h1.218Zm6.217,4.095h.731l-1.09-1.539a1.169,1.169,0,0,0,1.052-1.26,1.2,1.2,0,0,0-.334-.935,1.2,1.2,0,0,0-.925-.36H-69.8v4.095h.612V-5.754h.47Zm-1.516-3.536h.945a.665.665,0,0,1,.49.224.665.665,0,0,1,.163.513c0,.434-.232.737-.8.737h-.8Zm4.156,3.536h.612V-8.322h-.612Zm3.988.059a1.27,1.27,0,0,0,.957-.313,1.27,1.27,0,0,0,.428-.911c0-.6-.436-.975-1.123-1.147L-61.3-6.67c-.517-.133-.559-.4-.559-.535a.662.662,0,0,1,.237-.458.662.662,0,0,1,.494-.148.66.66,0,0,1,.5.164.66.66,0,0,1,.22.483h.6a1.21,1.21,0,0,0-.391-.891,1.21,1.21,0,0,0-.921-.315,1.25,1.25,0,0,0-.932.3,1.25,1.25,0,0,0-.431.878c0,.339.143.856,1.016,1.076l.523.131c.333.089.66.262.66.624a.685.685,0,0,1-.248.485.685.685,0,0,1-.524.15.784.784,0,0,1-.848-.689H-62.5a1.34,1.34,0,0,0,.465.931A1.34,1.34,0,0,0-61.044-4.167Zm6.252-.059-1.9-2.045,1.569-2.05h-.749l-1.29,1.7v-1.7h-.6v4.095h.6V-5.911l1.551,1.684Zm8.618,0-.5-4.095h-.545l-1.411,2.948-1.409-2.948h-.549l-.5,4.095h.6l.363-2.972,1.23,2.52h.523l1.218-2.52.363,2.972Zm4.507,0h.644l-1.549-4.095h-.654l-1.551,4.095h.644l.38-1.034h1.7ZM-43.559-5.8l.654-1.765.654,1.765Zm6.52-2.526v2.96l-1.771-2.96H-39.4v4.095h.612V-7.21L-37-4.227h.577V-8.322Zm5.349,4.095h.644l-1.545-4.095h-.654L-34.8-4.227h.644l.38-1.034h1.7ZM-33.58-5.8l.654-1.765.654,1.765ZM-27.7-4.167c1.177,0,1.949-.678,1.949-2.134H-27.6v.523h1.179a.524.524,0,0,1-.012.1,1.18,1.18,0,0,1-1.268.947A1.493,1.493,0,0,1-28.747-5.2a1.493,1.493,0,0,1-.411-1.072,1.494,1.494,0,0,1,.41-1.074A1.494,1.494,0,0,1-27.7-7.807a1.457,1.457,0,0,1,.987.392l.428-.392A2,2,0,0,0-27.7-8.371a2.075,2.075,0,0,0-1.477.618,2.075,2.075,0,0,0-.6,1.486,2.074,2.074,0,0,0,.6,1.484A2.074,2.074,0,0,0-27.7-4.167Zm4.358-.618V-5.956h1.611v-.565H-23.34V-7.763h1.848v-.559h-2.455v4.095h2.508v-.559Zm8.5.559-.5-4.095h-.545L-17.29-5.374-18.7-8.322h-.545l-.5,4.095h.608l.363-2.972,1.228,2.52h.523L-15.8-7.2l.363,2.972Zm2.55-.559V-5.956h1.611v-.565h-1.611V-7.763h1.848v-.559h-2.455v4.095h2.508v-.559Zm6.191-3.536v2.96l-1.769-2.96h-.594v4.095h.614V-7.21l1.787,2.984h.577V-8.322Zm5.4,0H-3.741v.559h1.218v3.536h.612V-7.763H-.692Z",
    transform: "translate(131.861 26.952)",
    fill: "#16354d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdiliaClark);
export default __webpack_public_path__ + "static/media/OdiliaClark.59fe8e04de30cd2a3589c6776c69ae2a.svg";
export { ForwardRef as ReactComponent };